module.exports = __webpack_public_path__ + "img/pc_banner_sup_acc.6736527f.webp";